/**
 * How the chosen one of a row of choices looks (#615, after #567).
 *
 * The chosen one is the page's own surface with a 2px outline in the
 * foreground colour and bold text; the others keep a light 1px border and
 * normal weight. Fill alone told them apart too weakly (grey, #567) and an
 * inverted near-black fill read as a button to press rather than a state
 * (#615), so outline thickness and weight carry it, and it reads the same in
 * light and dark because every part is a theme token. Pair it with
 * `aria-pressed` or `aria-checked`, which carry the same fact to assistive
 * tech.
 *
 * The outline is drawn *inside* the box (`outline` with a negative offset), so
 * it covers a 1px border or none at all and the box never changes size when
 * the choice moves.
 */
export const SELECTED_CHOICE =
  "border-transparent bg-background text-foreground font-bold outline-solid outline-2 -outline-offset-2 outline-foreground shadow-sm hover:bg-background hover:text-foreground";
